import React from "react";

import { Button } from "~/components/button";
import { ColorPicker } from "~/components/color-picker";
import { useScope } from "~/tools/impulse";

import { Popover } from "../../react/popover/Popover";

import { WidgetColor } from "./form-state";

export interface WidgetColorFieldProps {
	className?: string;
	color: WidgetColor;
}

export const WidgetColorField: React.FC<WidgetColorFieldProps> = ({ className, color }) => {
	const scope = useScope();

	return (
		<Popover
			className={className}
			content={
				<ColorPicker
					color={color.getInput(scope)}
					onChange={(value) => color.setInput(value)}
					presetColors={WidgetColor.preset}
				/>
			}
			destroyTooltipOnHide
			trigger="click"
		>
			<Button className="rounded-full" icon size="sm" variant="neutral">
				<div className="size-6 rounded-full" style={{ backgroundColor: color.getInput(scope) }} />
			</Button>
		</Popover>
	);
};
